module.exports = __webpack_public_path__ + "img/search.dd1df516.png";